import React from 'react';
import * as Actions from '../../../actions/operatingStatistics';
import tushu from './images/tushu.png';
import wzIco from './images/wz-ico.png';
import wxIco from './images/wx-ico.png';
import wbIco from './images/wb-ico.png';
import './publishInfo.scss';

class PublishInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {}

        }
    }

    componentDidMount() {
        Actions.findTodayPublishInfo({}, (res) => {
            let data = {};
            data.totalDay = res.totalDay
            data.totalAll = res.totalAll

            data.siteDay = res.siteDay
            data.siteAll = res.siteAll

            data.weixinDay = res.weixinDay
            data.weixinAll = res.weixinAll

            data.weiboDay = res.weiboDay
            data.weiboAll = res.weiboAll
            this.setState({
                data
            })
        })

    }

    render() {
        const { data } = this.state;
        return (
            <div className="publish-info">
                <div className="first">
                    <div className="left">
                        <img src={tushu} alt="" />
                    </div>
                    <div className="right">
                        <div>
                            <span>{data.totalDay && data.totalDay}</span>
                            <span>今日发文量</span>
                        </div>
                        <div>
                            <span>{data.totalAll && data.totalAll}</span>
                            <span>累计发文量</span>
                        </div>
                    </div>
                </div>
                <div className="item">
                    <div className="top">
                        <div className="pic">
                            <img src={wzIco} alt="" />
                        </div>
                        <span>网站</span>
                    </div>
                    <div className="bottom">
                        <span>今日发文</span>
                        <span>{data.siteDay && data.siteDay}</span>
                        <span>累计总发文量</span>
                        <span>{data.siteAll && data.siteAll}</span>
                    </div>
                </div>
                <div className="item">
                    <div className="top">
                        <div className="pic">
                            <img src={wxIco} alt="" />
                        </div>
                        <span>微信</span>
                    </div>
                    <div className="bottom">
                        <span>今日发文</span>
                        <span>{data.weixinDay && data.weixinDay}</span>
                        <span>累计总发文量</span>
                        <span>{data.weixinAll && data.weixinAll}</span>
                    </div>
                </div>
                <div className="item">
                    <div className="top">
                        <div className="pic">
                            <img src={wbIco} alt="" />
                        </div>
                        <span>微博</span>
                    </div>
                    <div className="bottom">
                        <span>今日发文</span>
                        <span>{data.weiboDay && data.weiboDay}</span>
                        <span>累计总发文量</span>
                        <span>{data.weiboAll && data.weiboAll}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PublishInfo